import { render, staticRenderFns } from "./privacyEn.vue?vue&type=template&id=bf93d10e&scoped=true&"
import script from "./privacyEn.vue?vue&type=script&lang=js&"
export * from "./privacyEn.vue?vue&type=script&lang=js&"
import style0 from "./privacyEn.vue?vue&type=style&index=0&id=bf93d10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf93d10e",
  null
  
)

export default component.exports